import React from "react";
import whatsappIcon from "../assets/Icons/whatsapp-icon.png";

const ChatBubble = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: "15px",
        right: "15px",
        zIndex: 1000,
      }}
    >
      <div className="chat-hover-area">
        {/* Chat Message */}
        <div className="chat-message">
          Hey there! How can we assist you today?
          <div className="chat-pointer" />
        </div>

        {/* WhatsApp Icon */}
        <div className="chat-icon">
          <a
            href="https://api.whatsapp.com/send?phone=923002241515"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={whatsappIcon} alt="WhatsApp Icon" className="chat-img" />
          </a>
        </div>
      </div>

      {/* Style block */}
      <style>{`
        .chat-hover-area {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }

        .chat-message {
          position: absolute;
          bottom: 75px;
          right: 0;
          background-color: #128c7e;
          padding: 14px 20px;
          border-radius: 20px;
          max-width: 260px;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
          font-size: 12px;
          color: #fff;
          font-weight: 500;
          text-align: right;
          display: none;
          white-space: nowrap;
        }

        .chat-pointer {
          position: absolute;
          bottom: -10px;
          right: 20px;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid #128c7e;
        }

        .chat-icon {
          background-color: #128c7e;
          border-radius: 50%;
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
          padding: 8px;
          cursor: pointer;
        }

        .chat-img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
        }

        /* Show message on hover */
        .chat-hover-area:hover .chat-message {
          display: block;
        }
      `}</style>
    </div>
  );
};

export default ChatBubble;
